<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">
			<li>
				<span>46、Did you find Rubber gaskets complete and without permanent indentations（橡胶垫片是否完整且无难以修复刻痕）</span>
				<span v-if="data3.jz201 == 1">yes</span>
				<span v-if="data3.jz201 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz202 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz203" />
			</li>
			<li>
				<span>47、Did you find coamings well and compression bars maintained（舱口围状态良好）</span>
				<span v-if="data3.jz204 == 1">yes</span>
				<span v-if="data3.jz204 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz205 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz206" />
			</li>
			<li>
				<span>48、Did you find Bilge pump without return valve or fully operative?（污水泵有无反水，以及阀门是否工作正常）</span>
				<span v-if="data3.jz207 == 1">yes</span>
				<span v-if="data3.jz207 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz208 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz209" />
			</li>
			<li>
				<span>49、Did you find cleats complete and workable?（压紧器是否正常）</span>
				<span v-if="data3.jz210 == 1">yes</span>
				<span v-if="data3.jz210 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz211 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz212" />
			</li>
			<li>
				<span>50、Did you find hatches watertight（舱盖水密情况）</span>
				<span v-if="data3.jz213 == 1">yes</span>
				<span v-if="data3.jz213 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz214 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz215" />
			</li>
			<li>
				<span>51、write the name of the last three previous cargo（最后三种货物名称）</span>
				<span>{{ data3.jz216 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz217 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz218" />
			</li>
			<li>
				<span>52、Did you find holds washed by fresh water prior to loading?（装货前是否用淡水洗舱）</span>
				<span v-if="data3.jz219 == 1">yes</span>
				<span v-if="data3.jz219 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz220 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz221" />
			</li>
			<li>
				<span>53、Are Man Hole Entrance in good conditions?（下舱人孔是否正常）</span>
				<span v-if="data3.jz222 == 1">yes</span>
				<span v-if="data3.jz222 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz223 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz224" />
			</li>
			<li>
				<span>54、 Draining Hole and draining pipes In good conditions（放残孔/管路是否正常）</span>
				<span v-if="data3.jz225 == 1">yes</span>
				<span v-if="data3.jz225 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz226 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz227" />
			</li>
			<li>
				<span>55、Chloride test delivered POSITIVE reaction（氯离子检测是否呈阳性）</span>
				<span>{{ data3.jz228 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz229 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz230" />
			</li>
			<li>
				<span>56、Show the type and the condition of the ventilation（通风孔情况）</span>
				<span>{{ data3.jz231 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz232 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz233" />
			</li>
			<li>
				<span>57、Show if the rubber gaskets, the coamings, the compression bars and the cleats are in good conditions</span>
				<span v-if="data3.jz234 == 1">yes</span>
				<span v-if="data3.jz234 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz235 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz236" />
			</li>
			<li>
				<span>58、Show if the holds are clean and dry and if the silver nitrate test gave negative reaction</span>
				<span v-if="data3.jz237 == 1">yes</span>
				<span v-if="data3.jz237 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz238 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz239" />
			</li>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'workStart3',
	components: {
		navTop
	},
	data() {
		return {
			data3: {}
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.getSchedulejz();
		}
	},
	methods: {
		getSchedulejz() {
			let data = {
				id: this.id
			};
			this.$api.schedulejz(data).then((res) => {
				console.log(res);
				if (res.result == 0) {
					this.data3 = res.data2;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		width: 100%;
		margin: 50px auto;
		border: 1px solid rgba(0, 255, 255, 0.25);
		border-radius: 10px;
		padding: 45px 154px 38px 56px;
		box-sizing: border-box;
		box-shadow: 0 0 300px 100px #043138 inset;
		p {
			color: #00fff0;
			font-size: 25px;
			line-height: 1em;
			text-align: center;
			font-weight: bold;
			margin-bottom: 10px;
		}
		li {
			display: flex;
			flex-direction: column;
			padding-bottom: 20px;
			box-sizing: border-box;
			span:nth-child(1) {
				color: #00fff0;
				font-size: 24px;
				line-height: 1em;
			}
			span:nth-child(2) {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			img {
				margin-top: 15px;
				display: block;
				width: 392px;
				height: 292px;
				border-radius: 10px;
			}
		}
	}
}
</style>
